import { Header } from "shared/Header/Header";
import { PageHead } from "gui/head/head";
import { PageMain } from "gui/page/page";
import { Redirect } from "gui/redirect/redirect";
import { RedirectProps } from "gui/redirect/redirect";

export const RedirectPage: React.FC<RedirectProps> = (props) => {
  return (
    <>
      <PageHead title="Dune" />
      <Header />
      <PageMain size="md">
        <Redirect {...props} />
      </PageMain>
    </>
  );
};
